/* =====================================================================
   RYNOR – Mystery piece add-on in the cart drawer
   Theme editor › Footer › "Cart: mystery piece" (sections/rynor-cart-mystery.liquid puts the
   settings in <script data-rynor-mystery-config>).

   - Puts a one-tap row at the top of the checkout footer whenever the cart has items and no
     mystery piece yet. Nothing is pre-ticked and nothing pops up.
   - ADD puts the product in the cart as a normal line, re-draws the drawer with the theme's own
     code, then scrolls to the new line and flashes it once.
   - When adding it takes the cart over the free-shipping amount, the second line says so.
     The cart total and free-shipping amount come from the bar's own numbers
     (snippets/cart-shipping-countdown.liquid), like assets/rynor-ship-cost.js.
   - The add goes through XMLHttpRequest on purpose: assets/rynor-pixels.js only watches fetch(),
     so a $12 add-on from inside the cart isn't sent to the ad platforms as a fresh add_to_cart
     (same as shipping protection). Purchases still report the full order value.
   ===================================================================== */
(function () {
  'use strict';

  if (window.RynorCartMystery) return;

  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queued = false;
  var busy = false;
  var flashVariant = null;
  var sizer = window.ResizeObserver ? new ResizeObserver(function () { fitScrollArea(); }) : null;
  var sized = [];

  var PLUS = '<svg class="icon-plus" width="24" height="24" viewBox="0 -960 960 960" aria-hidden="true" focusable="false">' +
    '<path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"></path></svg>';

  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function config() {
    var el = qs('script[data-rynor-mystery-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function scope() {
    return document.getElementById('slideout-ajax-cart') || document.getElementById('modal-ajax-cart') || document;
  }

  /* ---------- cart state, read from what the theme just drew ---------- */
  function inCart(variantId) {
    var prefix = String(variantId) + ':';
    return qsa('[data-item-key]', scope()).some(function (el) {
      return (el.getAttribute('data-item-key') || '').indexOf(prefix) === 0;
    });
  }

  function cartEmpty() {
    var form = qs('.js-cart-form', scope());
    if (!form || form.classList.contains('hide')) return true;
    var meta = qs('[data-rynor-cart-meta]', scope());
    if (meta) return (parseInt(meta.getAttribute('data-visible-count'), 10) || 0) < 1;
    return !qs('[data-item-key]', scope());
  }

  /* true when adding `priceCents` takes the cart from under to at/over free shipping */
  function unlocksFreeShipping(priceCents) {
    var root = scope();
    var bar = qs('.cart-shipping-countdown', root);
    var from = qs('template[data-rynor-free-ship]', root) || bar;
    if (!from) return false;
    var thresholdShop = parseInt(from.getAttribute('data-threshold-shop-cents'), 10) || 0;
    var total = parseInt(from.getAttribute('data-total-cents'), 10) || 0;
    var same = from.getAttribute('data-same-currency') !== 'false';
    var threshold = thresholdShop;
    if (!same) {
      var I = window.RynorI18n;
      threshold = I ? Math.ceil(I.toLocalCents(thresholdShop) / 100) * 100 : 0;
    }
    if (thresholdShop < 2 || threshold < 1 || total < 1) return false;
    return total < threshold && total + priceCents >= threshold;
  }

  /* ---------- the row ---------- */
  function build(cfg) {
    var row = document.createElement('div');
    row.className = 'rynor-mystery';
    row.setAttribute('data-rynor-mystery', '');

    var media = document.createElement('span');
    media.className = 'rynor-mystery__media';
    if (cfg.image) {
      var img = document.createElement('img');
      img.src = cfg.image;
      if (cfg.image_2x) img.srcset = cfg.image + ' 1x, ' + cfg.image_2x + ' 2x';
      img.alt = '';
      img.width = 46;
      img.height = 56;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }

    var info = document.createElement('div');
    info.className = 'rynor-mystery__info';
    var title = document.createElement('p');
    title.className = 'rynor-mystery__title';
    title.textContent = cfg.title || '';
    var desc = document.createElement('p');
    desc.className = 'rynor-mystery__desc';
    desc.setAttribute('data-rynor-mystery-desc', '');
    var price = document.createElement('div');
    price.className = 'rynor-mystery__price';
    var now = document.createElement('span');
    now.className = 'rynor-mystery__now';
    now.textContent = cfg.price || '';
    price.appendChild(now);
    if (cfg.compare) {
      var was = document.createElement('s');
      was.className = 'rynor-mystery__was';
      was.textContent = cfg.compare;
      price.appendChild(was);
    }
    info.appendChild(title);
    info.appendChild(desc);
    info.appendChild(price);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rynor-mystery__add';
    button.setAttribute('data-rynor-mystery-add', '');
    button.setAttribute('aria-label', (cfg.button || 'Add') + ': ' + (cfg.title || '') + ', ' + (cfg.price || ''));
    button.innerHTML = '<span data-rynor-mystery-label></span>' + PLUS;
    button.querySelector('[data-rynor-mystery-label]').textContent = cfg.button || 'Add';

    row.appendChild(media);
    row.appendChild(info);
    row.appendChild(button);
    row.__rynorKey = rowKey(cfg);
    return row;
  }

  function rowKey(cfg) {
    return [cfg.variant_id, cfg.title, cfg.price, cfg.compare, cfg.image, cfg.button].join('|');
  }

  function setDesc(row, cfg) {
    var nudge = !!cfg.nudge && unlocksFreeShipping(parseInt(cfg.price_cents, 10) || 0);
    var text = nudge ? cfg.nudge : (cfg.desc || '');
    var el = qs('[data-rynor-mystery-desc]', row);
    if (el && el.textContent !== text) el.textContent = text;
    if (el && el.hidden !== !text) el.hidden = !text;
    /* only touch the class when it changes: a no-op class write still wakes the observers */
    if (row.classList.contains('is-nudge') !== nudge) row.classList.toggle('is-nudge', nudge);
  }

  function removeRows() {
    qsa('[data-rynor-mystery]').forEach(function (row) { row.remove(); });
  }

  /* footer height → scroll area padding (CSS in the section reads --rynor-summary-h) */
  function fitScrollArea() {
    var d = document.getElementById('slideout-ajax-cart');
    if (!d) return;
    var area = qs('.ajax-cart__scroll-area', d);
    var summary = qs('.js-cart-summary', d);
    if (!area || !summary) return;
    var h = Math.ceil(summary.getBoundingClientRect().height);
    if (h > 0) area.style.setProperty('--rynor-summary-h', h + 'px');
  }

  function render() {
    queued = false;
    watch(); /* the theme re-draws the footer after every change: keep sizing the new one */
    var cfg = config();
    var summaries = qsa('.js-cart-summary', scope());

    var show = !!(cfg && cfg.enabled && cfg.variant_id) && !cartEmpty() && !inCart(cfg.variant_id);
    if (!show) {
      if (!busy) removeRows();
      return;
    }

    summaries.forEach(function (summary) {
      var row = qs('[data-rynor-mystery]', summary);
      if (row && row.__rynorKey !== rowKey(cfg)) { row.remove(); row = null; }
      if (!row) {
        row = build(cfg);
        summary.insertBefore(row, summary.firstChild);
      }
      setDesc(row, cfg);
    });

    if (window.requestAnimationFrame) window.requestAnimationFrame(fitScrollArea);
    else fitScrollArea();
  }

  function queue() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(render);
    else window.setTimeout(render, 16);
  }

  /* ---------- adding it ---------- */
  function postCart(path, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', routesRoot + path, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.responseText);
        else reject(new Error('Cart request failed (' + xhr.status + ')'));
      };
      xhr.onerror = function () { reject(new Error('Network error')); };
      xhr.send(JSON.stringify(body));
    });
  }

  function cartConfig() {
    var el = document.getElementById('cart-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  /* re-draw the drawer with the theme's own code (same path as the qty buttons) */
  function redrawCart() {
    var conf = cartConfig();
    var W = window.WAU;
    if (!conf || !W || !W.ThemeCart || !W.AjaxCart || typeof W.AjaxCart.updateView !== 'function') {
      return Promise.resolve(false);
    }
    return W.ThemeCart.getCart().then(function (cart) {
      W.AjaxCart.updateView(conf, cart);
      return true;
    });
  }

  function setBusy(on, cfg) {
    qsa('[data-rynor-mystery]').forEach(function (row) {
      row.classList.toggle('is-busy', on);
      if (on) row.setAttribute('aria-busy', 'true');
      else row.removeAttribute('aria-busy');
      var label = qs('[data-rynor-mystery-label]', row);
      if (label && cfg) label.textContent = on ? (cfg.adding || cfg.button) : (cfg.button || 'Add');
    });
  }

  function showNewLine(variantId) {
    var prefix = String(variantId) + ':';
    var key = qsa('[data-item-key]', scope()).filter(function (el) {
      return (el.getAttribute('data-item-key') || '').indexOf(prefix) === 0;
    })[0];
    var line = key && key.closest('.line-item, .ajax-cart__cart-item');
    if (!line) return;
    var area = line.closest('.ajax-cart__scroll-area');
    if (area) {
      var a = area.getBoundingClientRect();
      var l = line.getBoundingClientRect();
      var pad = parseFloat(window.getComputedStyle(area).paddingBottom) || 0;
      var visibleBottom = a.bottom - pad;
      if (l.bottom > visibleBottom || l.top < a.top) {
        var target = area.scrollTop + (l.bottom - visibleBottom) + 12;
        if (l.top < a.top) target = area.scrollTop - (a.top - l.top) - 12;
        try { area.scrollTo({ top: target, behavior: 'smooth' }); } catch (e) { area.scrollTop = target; }
      }
    }
    line.classList.remove('rynor-mystery-flash');
    void line.offsetWidth;
    line.classList.add('rynor-mystery-flash');
  }

  function add() {
    var cfg = config();
    if (!cfg || !cfg.enabled || !cfg.variant_id || busy) return;
    busy = true;
    setBusy(true, cfg);

    postCart('cart/add.js', { items: [{ id: cfg.variant_id, quantity: 1 }] })
      .then(function () { return redrawCart(); })
      .then(function (redrawn) {
        busy = false;
        if (!redrawn) { window.location.reload(); return; }
        setBusy(false, cfg);
        flashVariant = cfg.variant_id;
        queue();
        try {
          document.dispatchEvent(new CustomEvent('rynor:mystery-added', { detail: { variantId: cfg.variant_id } }));
        } catch (e) {}
      })
      .catch(function (err) {
        busy = false;
        setBusy(false, cfg);
        if (window.console) console.warn('[rynor-cart-mystery]', err && err.message);
        redrawCart();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-rynor-mystery-add]');
    if (!btn) return;
    e.preventDefault();
    add();
  });

  /* ---------- wiring ---------- */
  var observer = new MutationObserver(function () {
    queue();
    if (flashVariant && !busy) {
      var v = flashVariant;
      if (inCart(v)) {
        flashVariant = null;
        window.setTimeout(function () { showNewLine(v); }, 60);
      }
    }
  });

  function watch() {
    qsa('.js-ajax-cart-content').forEach(function (el) {
      if (el.__rynorMysteryWatched) return;
      el.__rynorMysteryWatched = true;
      observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    var d = document.getElementById('slideout-ajax-cart');
    /* the footer can change height on its own (shipping line, protection row, a phone rotating) */
    if (sizer) {
      var current = qsa('.js-cart-summary', scope());
      var stale = current.some(function (el) { return sized.indexOf(el) < 0; });
      if (stale) {
        sizer.disconnect(); /* let go of the footer the theme just replaced */
        sized = current;
        current.forEach(function (el) { sizer.observe(el); });
      }
    }
    if (d && !d.__rynorMysteryWatched) {
      d.__rynorMysteryWatched = true;
      new MutationObserver(function () {
        if (d.classList.contains('slideout--active')) {
          queue();
          window.setTimeout(fitScrollArea, 60);
        }
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    watch();
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('load', function () { watch(); queue(); });
  window.addEventListener('resize', function () { window.requestAnimationFrame(fitScrollArea); });

  /* theme editor: the switch was flipped or a setting changed */
  document.addEventListener('shopify:section:load', function () {
    removeRows();
    watch();
    queue();
  });

  window.RynorCartMystery = { refresh: render, add: add };
})();
